/**
 * sourceHierarchy.js
 * Adventist denominational source hierarchy constants.
 *
 * Priority order (higher = more authoritative):
 *   5 — Biblia
 *   4 — Creencias Fundamentales
 *   3 — Manual de Iglesia
 *   2 — EGW (escritos)
 *   1 — Recursos pastorales / guías de división
 */

export const SOURCE_PRIORITY = {
  bible:              5,
  fundamental_beliefs: 4,
  church_manual:      3,
  egw:                2,
  pastoral_resource:  1,
};

export const SOURCE_LABELS = {
  bible:         "Biblia",
  church_manual: "Manual de Iglesia",
  egw:           "Elena G. White",
  pastoral_resource: "Recurso pastoral",
};

// Authority weights used as defaults when not stored in chunk metadata
export const DEFAULT_AUTHORITY_WEIGHTS = {
  sc:     1.0,   // El Camino a Cristo
  da:     1.0,   // El Deseado de Todas las Gentes
  mp:     0.95,  // Ministerio Pastoral
  ev:     0.90,  // Obreros Evangélicos
  cc:     0.90,  // Consejos para la Iglesia
  lde:    0.85,  // Eventos de los Últimos Días
  cm2020: 0.90,  // Manual de Iglesia 2020
};

/**
 * Given a question type, return the ordered list of sources to query.
 * Mirrors the backend denominational reasoning.
 */
export const QUESTION_TYPE_SOURCES = {
  administrative: { primary: "church_manual", sourceTypes: ["church_manual"], citationDensity: "medium" },
  pastoral:       { primary: "egw",           sourceTypes: ["egw"],           citationDensity: "low"    },
  devotional:     { primary: "egw",           sourceTypes: ["egw"],           citationDensity: "low"    },
  sermon_support: { primary: "egw",           sourceTypes: ["egw"],           citationDensity: "low"    },
  doctrinal:      { primary: "bible",         sourceTypes: [],                citationDensity: "none"   },
  none:           { primary: null,            sourceTypes: [],                citationDensity: "none"   },
};
